import React from 'react';
import { Link } from 'react-router-dom';
import { useAcademy } from '../AcademyContext';

const initials = (name) =>
  (name || '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase() || '·';

const AcademyNav = () => {
  const { member, logout } = useAcademy();

  return (
    <header className="ac-nav">
      <div className="ac-nav-inner">
        <Link to="/academy" className="ac-nav-brand">
          <img src="/img/sg_bonusclub_combo_white.png" alt="SalesGod · BonusClub" className="ac-nav-logo" />
          <span className="ac-nav-tag">Academy</span>
        </Link>

        <div className="ac-nav-right">
          {member && (
            <div className="ac-nav-member">
              <span className="ac-nav-avatar" aria-hidden="true">{initials(member.name)}</span>
              <span className="ac-nav-member-name">{member.name || 'Member'}</span>
              <button type="button" className="ac-nav-signout" onClick={logout} title="Sign out">
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AcademyNav;
